export const MessengerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.75979C0 3.30191 3.494 0 8 0C12.506 0 16 3.30391 16 7.76179C16 12.2197 12.506 15.5216 8 15.5216C7.19 15.5216 6.414 15.4136 5.684 15.2136C5.542 15.1756 5.39 15.1856 5.256 15.2456L3.668 15.9456C3.57209 15.9879 3.46726 16.006 3.36272 15.9983C3.25818 15.9906 3.15712 15.9573 3.06844 15.9014C2.97977 15.8455 2.90617 15.7687 2.85413 15.6777C2.80209 15.5867 2.7732 15.4844 2.77 15.3796L2.726 13.9556C2.722 13.7796 2.642 13.6156 2.512 13.4996C0.956 12.1077 0 10.0917 0 7.75979ZM5.54601 6.30183L3.19601 10.0297C2.97001 10.3877 3.41001 10.7897 3.74601 10.5337L6.27001 8.61776C6.35306 8.55469 6.45439 8.52038 6.55867 8.52001C6.66296 8.51965 6.76453 8.55326 6.84801 8.61576L8.71801 10.0177C8.85064 10.1173 9.00249 10.1884 9.16397 10.2263C9.32544 10.2643 9.49303 10.2684 9.65616 10.2383C9.81929 10.2082 9.97441 10.1447 10.1117 10.0516C10.2491 9.95859 10.3656 9.83809 10.454 9.69773L12.806 5.97184C13.03 5.61385 12.59 5.20986 12.254 5.46585L9.73001 7.3818C9.64696 7.44487 9.54563 7.47919 9.44134 7.47955C9.33706 7.47991 9.23549 7.4463 9.15201 7.3838L7.28201 5.98184C7.14937 5.88223 6.99752 5.8112 6.83605 5.77323C6.67457 5.73527 6.50698 5.73119 6.34385 5.76126C6.18073 5.79133 6.0256 5.85489 5.88828 5.94793C5.75095 6.04097 5.63441 6.16148 5.54601 6.30183Z"
        fill="#18181B"
      />
    </svg>
  );
};
